import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

export type AppId = string;
export type CategoryId = string;
export type Date = string;
export type OverTimeAgeRecord = Record<Date, IDemographicsAgeResponse>;
export type OverTimeGenderRecord = Record<Date, IDemographicsGenderResponse>;
export interface IDemographicsWidgetReqParams {
    country: number;
    store: string;
    includeSubDomains: boolean;
    timeGranularity: GranularityNames;
    to: string;
    from: string;
    isWindow: boolean;
    keys: string;
}

export interface IDemographicsWidgetsData {
    averageData: IDemographicsAverageData;
    overTimeData: IDemographicsOverTimeData;
    overTimeCategoriesData: IDemographicsOverTimeData;
    requestParams: IDemographicsWidgetReqParams;
}
interface IDemographicsAverageData {
    age: Record<AppId, IDemographicsAgeResponse>;
    gender: Record<AppId, IDemographicsGenderResponse>;
}

export interface IDemographicsOverTimeData {
    /* eslint-disable @typescript-eslint/no-duplicate-type-constituents */
    age: Record<AppId | CategoryId, OverTimeAgeRecord>;
    gender: Record<AppId | CategoryId, OverTimeGenderRecord>;
    /* eslint-enable @typescript-eslint/no-duplicate-type-constituents */
}

export interface IDemographicsServerResponse {
    AppsDemographics: DemographicsAppsRecord;
    CategoriesDemographics: DemographicsCategoriesRecord;
}

export type DemographicsCategoriesRecord = Record<
    CategoryId,
    Record<Date, Record<Demographic, IDemographicsAgeResponse | IDemographicsGenderResponse>>
>;

export type DemographicsAppsRecord = Record<
    AppId,
    {
        Overtime: Record<Date, Record<Demographic, IDemographicsAgeResponse | IDemographicsGenderResponse>>;
        Average: Record<Demographic, IDemographicsAgeResponse | IDemographicsGenderResponse>;
    }
>;

export interface IDemographicsGenderResponse {
    Female: number;
    Male: number;
}

export interface IDemographicsAgeResponse {
    Age18To24: number;
    Age25To34: number;
    Age35To44: number;
    Age45To54: number;
    Age55Plus: number;
}

export enum Demographic {
    AGE = "age",
    GENDER = "gender",
}
